var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jo7t7sj8ea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15494",
    style: {
      fill: "none"
    },
    d: "M0 0h60v70H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59776",
    d: "m0 38.841 4.5 3.765v-3.765z",
    transform: "translate(0 -11.227)",
    style: {
      fill: "#ad1515"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 888"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 887",
    style: {
      clipPath: "url(#jo7t7sj8ea)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59777",
    d: "M44.456 0H8.789a3.4 3.4 0 0 0-3.378 3.419v63.163A3.4 3.4 0 0 0 8.789 70h49.442a3.4 3.4 0 0 0 3.378-3.418V17.453a.712.712 0 0 0-.2-.5L44.955.21a.7.7 0 0 0-.5-.21",
    transform: "translate(-1.61)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59778",
    d: "M58.529 69.578H9.086a2.692 2.692 0 0 1-2.675-2.708V3.707A2.692 2.692 0 0 1 9.086 1h35.668L61.2 17.742V66.87a2.692 2.692 0 0 1-2.676 2.708",
    transform: "translate(-1.907 -.289)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59779",
    d: "M62.067 17.453h16.075L60.989 0v16.362a1.085 1.085 0 0 0 1.078 1.091",
    transform: "translate(-18.142)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15489",
    transform: "translate(15.471 34.289)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15490",
    transform: "translate(15.471 42.829)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15491",
    transform: "translate(15.471 51.369)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15492",
    transform: "translate(15.471 59.91)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15493",
    transform: "translate(0 11.904)",
    style: {
      fill: "#e5322e"
    },
    d: "M0 0h34.523v15.71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59780",
    d: "M14.1 27.177V29.7h-1.17v-6.809h2.575a2.586 2.586 0 0 1 1.791.6 2.011 2.011 0 0 1 .664 1.573 1.945 1.945 0 0 1-.65 1.561 2.711 2.711 0 0 1-1.82.557zm0-.954h1.405a1.376 1.376 0 0 0 .953-.3 1.1 1.1 0 0 0 .328-.859 1.186 1.186 0 0 0-.332-.882 1.278 1.278 0 0 0-.916-.339H14.1z",
    transform: "translate(-3.847 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59781",
    d: "M21.68 29.7v-6.809h1.988a3.082 3.082 0 0 1 1.583.4 2.73 2.73 0 0 1 1.071 1.141 3.665 3.665 0 0 1 .379 1.693v.341a3.646 3.646 0 0 1-.381 1.7 2.694 2.694 0 0 1-1.086 1.132 3.23 3.23 0 0 1-1.616.4zm1.17-5.857v4.912h.763a1.747 1.747 0 0 0 1.412-.582 2.559 2.559 0 0 0 .5-1.673v-.379a2.626 2.626 0 0 0-.476-1.693 1.68 1.68 0 0 0-1.382-.584z",
    transform: "translate(-6.449 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59782",
    d: "M34.5 26.817h-2.711V29.7h-1.17v-6.809H34.9v.954h-3.111v2.026H34.5z",
    transform: "translate(-9.108 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59783",
    d: "M13.878 30.02h-1.17a.53.53 0 0 1-.527-.533v-6.813a.53.53 0 0 1 .527-.533h2.575a3.1 3.1 0 0 1 2.141.729 2.536 2.536 0 0 1 .841 1.972 2.468 2.468 0 0 1-.836 1.967 3.22 3.22 0 0 1-2.16.683H14.4v1.994a.53.53 0 0 1-.527.533m-.643-1.066h.116V26.96a.532.532 0 0 1 .292-.477.532.532 0 0 1-.292-.477v-2.377a.536.536 0 0 1 .2-.422h-.32zm3.283-5.442c.027.024.055.05.081.076a1.709 1.709 0 0 1 .491 1.263 1.619 1.619 0 0 1-.5 1.257l-.034.031a1.361 1.361 0 0 0 .66-1.295 1.483 1.483 0 0 0-.486-1.174 1.616 1.616 0 0 0-.207-.158M14.4 25.473h.878a.891.891 0 0 0 .6-.162c.038-.033.152-.137.152-.461a.643.643 0 0 0-.175-.5.774.774 0 0 0-.554-.186h-.9z",
    transform: "translate(-3.623 -6.4)",
    style: {
      fill: "#ad1515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59784",
    d: "M23.394 30.019h-1.937a.53.53 0 0 1-.527-.533v-6.812a.53.53 0 0 1 .527-.533h1.988a3.617 3.617 0 0 1 1.846.474 3.261 3.261 0 0 1 1.274 1.357 4.214 4.214 0 0 1 .435 1.94v.341a4.2 4.2 0 0 1-.441 1.951 3.234 3.234 0 0 1-1.3 1.35 3.767 3.767 0 0 1-1.872.465m-1.41-1.066h.308a.535.535 0 0 1-.192-.412v-4.912a.536.536 0 0 1 .2-.422h-.32zm3.373-4.911a3.324 3.324 0 0 1 .474 1.866v.379a3.166 3.166 0 0 1-.559 1.934 2.253 2.253 0 0 0 .358-.511 3.127 3.127 0 0 0 .321-1.455v-.341a3.15 3.15 0 0 0-.32-1.448 2.359 2.359 0 0 0-.274-.422m-2.2 3.966h.236a1.242 1.242 0 0 0 1.012-.4 2.059 2.059 0 0 0 .375-1.331v-.374a2.132 2.132 0 0 0-.356-1.354 1.175 1.175 0 0 0-.975-.39h-.292z",
    transform: "translate(-6.226 -6.4)",
    style: {
      fill: "#ad1515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59785",
    d: "M31.566 30.019H30.4a.53.53 0 0 1-.527-.533v-6.812a.53.53 0 0 1 .527-.533h4.276a.53.53 0 0 1 .527.533v.955a.53.53 0 0 1-.527.533h-2.583v.958h2.182a.53.53 0 0 1 .527.533v.947a.53.53 0 0 1-.527.533h-2.182v2.353a.53.53 0 0 1-.527.533m-.643-1.066h.116V26.6a.534.534 0 0 1 .282-.473.534.534 0 0 1-.282-.473v-2.025a.535.535 0 0 1 .2-.422h-.32z",
    transform: "translate(-8.885 -6.4)",
    style: {
      fill: "#ad1515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59786",
    d: "M14.1 27.177V29.7h-1.17v-6.809h2.575a2.586 2.586 0 0 1 1.791.6 2.011 2.011 0 0 1 .664 1.573 1.945 1.945 0 0 1-.65 1.561 2.711 2.711 0 0 1-1.82.557zm0-.954h1.405a1.376 1.376 0 0 0 .953-.3 1.1 1.1 0 0 0 .328-.859 1.186 1.186 0 0 0-.332-.882 1.278 1.278 0 0 0-.916-.339H14.1z",
    transform: "translate(-3.847 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59787",
    d: "M21.68 29.7v-6.809h1.988a3.082 3.082 0 0 1 1.583.4 2.73 2.73 0 0 1 1.071 1.141 3.665 3.665 0 0 1 .379 1.693v.341a3.646 3.646 0 0 1-.381 1.7 2.694 2.694 0 0 1-1.086 1.132 3.23 3.23 0 0 1-1.616.4zm1.17-5.857v4.912h.763a1.747 1.747 0 0 0 1.412-.582 2.559 2.559 0 0 0 .5-1.673v-.379a2.626 2.626 0 0 0-.476-1.693 1.68 1.68 0 0 0-1.382-.584z",
    transform: "translate(-6.449 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59788",
    d: "M34.5 26.817h-2.711V29.7h-1.17v-6.809H34.9v.954h-3.111v2.026H34.5z",
    transform: "translate(-9.108 -6.617)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPdf);
export default __webpack_public_path__ + "static/media/ico_pdf.54a1163a93d2d88dc51e3f0a4d7ae4a6.svg";
export { ForwardRef as ReactComponent };